import { ApiService } from './../../services/api/api.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';

import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { ContractorSearchComponent } from './components/contractor-search.component';
import { AppMaterialComponentsModule } from '../app-material-components/app-material-components.module';
import { TruncateCharactersPipe } from '../../pipes/truncate.pipe';
import { DialogContractorReviewsComponent } from './components/dialog-contractor-reviews/dialog-contractor-reviews.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ContractorSearchComponent,
    TruncateCharactersPipe,
    DialogContractorReviewsComponent
  ],
  exports: [
    ContractorSearchComponent,
    TruncateCharactersPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppMaterialComponentsModule,
    FlexModule,
    FlexLayoutModule,
    MatIconModule,
    NgxTrimDirectiveModule
  ],
  providers: [
    ApiService
  ],
  // entryComponents: [
  //   DialogContractorReviewsComponent
  // ],
})
export class ContractorSearchModule { }
